/**
 * Display name from user object (first_name + last_name).
 */
export const formatUserName = (user) => {
  if (!user || typeof user !== 'object') return '';
  return `${user.first_name || ''} ${user.last_name || ''}`.trim();
};

export const formatUserNameOrFallback = (user, fallback = '—') => {
  const name = formatUserName(user);
  if (name) return name;
  if (user?.username) return user.username;
  if (user?.email) return user.email;
  if (typeof user === 'string') return user;
  return fallback;
};
